import request from '@/utils/request'

// 获取公告列表
export function getNoticePage(params) {
    return request({
        url: '/open/getNoticePage',
        method: 'get',
        params
    })
}

// 获取公告详情
export function getNoticeDetail(id) {
    return request({
        url: '/open/getNoticeDetail/'+id,
        method: 'get',
    })
}
